<sk-modal-content [title]="'label.dms.RenameFolder' | translate"
                  [isHideCloseBtn]="true"
                  confirmByKeypress
                  (confirmed)="renameFolder()"
                  (cancelled)="closeWithoutResult()"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <form [formGroup]="editFolderForm">
      <sk-text
        [label]="'label.FolderName' | translate"
        data-test="folder-rename-modal_name"
        formControlName="name"
      ></sk-text>
      @if (name.errors?.exists) {
        <mat-error class="error-folder-exists mt-1">
          {{ 'label.dms.FolderWithThisNameExists' | translate }}
        </mat-error>
      }
    </form>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      *irisIfLoaded="!duplicateChecking(); loaderType 'inline'"
      data-test="folder-rename-modal_submit-button"
      (click)="renameFolder()"
      [label]="'label.Save' | translate"
      [disabled]="editFolderForm.invalid">
      <ng-template buttonPrefix>
        <i class="fal fa-check check-icon"></i>
      </ng-template>
    </sk-button>
    <sk-button
      data-test="folder-rename-modal_close-button"
      (click)="closeWithoutResult()"
      [label]="'label.Cancel' | translate"
      [appearance]="'outlined'"
      [color]="'primary'"
    >
      <ng-template buttonPrefix>
        <i class="far fa-times"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
